import clsx from "clsx";
import React from "react";
import BackFilterItem from "web/react/components/back-filter-item/back-filter-item";
import CheckboxFilterItem from "web/react/components/checkbox-filter-item/checkbox-filter-item";
import environment from "web/script/modules/environment";
import { StandardFilterProps } from "web/types/feed-filters";
import { CategoryFilterOption } from "web/types/universal-filters";
import styles from "./category-filter-item.module.css";

interface CategoryFilterItemProps extends StandardFilterProps {
    item: CategoryFilterOption;
    siblingOpen?: boolean;
    goBackString: string;
}

function CategoryFilterItem({
    item,
    pendingFilterInfo,
    siblingOpen,
    goBackString,
    onClick,
}: CategoryFilterItemProps): JSX.Element {
    const open = pendingFilterInfo.getChecked(item);
    const enableRelevantFeedFilters = environment.getFeature("seo_enable_relevant_feed_filters");
    const shouldNotRenderChildren = !open && enableRelevantFeedFilters;

    // This url can change each time the user clicks something
    let expandableId = `category_filter_item_${item.url}`;

    const children = item.children.length > 0 && !shouldNotRenderChildren && (
        <ol
            className={clsx(styles.subOptionsGroup, {
                [styles.open]: open,
                [styles.closed]: !open,
                [styles.flatList]: enableRelevantFeedFilters,
            })}
            id={expandableId}
        >
            {item.children.map((item) => {
                return (
                    <li key={item.value}>
                        <CheckboxFilterItem
                            {...{
                                item,
                                pendingFilterInfo,
                                onClick,
                            }}
                            isSmallItem={true}
                        />
                    </li>
                );
            })}
        </ol>
    );

    /* ORG-2894, ORG-2940, ORG-2941 - Test: Show only relevant filters. */
    if (item.checked && !!item.children.length && enableRelevantFeedFilters) {
        return <div className={clsx(styles.filterGroup, styles.flatList)}>{children}</div>;
    }

    return (
        <li className={clsx(styles.filterGroup, styles.flatList)}>
            <CheckboxFilterItem
                {...{
                    item,
                    pendingFilterInfo,
                    onClick,
                    siblingOpen,
                }}
                ariaControls={expandableId}
                hasChildren={item.children.length > 0}
            />
            {children}
            {item.children.length > 0 && !enableRelevantFeedFilters && (
                <div className={clsx({ [styles.open]: open, [styles.closed]: !open })}>
                    <BackFilterItem
                        title={goBackString}
                        {...{
                            item,
                            pendingFilterInfo,
                            onClick,
                            siblingOpen,
                        }}
                        ariaControls={expandableId}
                        hasChildren={item.children.length > 0}
                    />
                </div>
            )}
        </li>
    );
}

export default CategoryFilterItem;
